import {AfriexAdminPermission} from '@afriex/core/domain/enums';

import {PermissionsProvider} from '@/components';
import type {AfriexQueryParams} from '@/types';

import LimitUpdateButton from './LimitUpdateButton';

export type BusinessLimitsFiltersProps = {
  currentFilters: AfriexQueryParams;
  clearFilters?: () => void;
  selectCurrentFilters: (
    name: string,
    value: string | Date | undefined,
  ) => void;
  handleAutoComplete: (search: string) => void;
  dataCy?: string;
};

const BusinessLimitsFilters: React.FC<BusinessLimitsFiltersProps> = ({
  dataCy,
}) => {
  return (
    <div className="mt-5 w-full">
      <div className="flex md:justify-end">
        <PermissionsProvider
          permission={AfriexAdminPermission.BusinessLimitManage}
        >
          <LimitUpdateButton dataCy={dataCy} />
        </PermissionsProvider>
      </div>
    </div>
  );
};

export default BusinessLimitsFilters;
